import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildCorporateActionsCapsuleConfigSlice } from 'widgets/corpActions/capsule/store/configslice';
import { CorporateActionsCapsuleState } from 'widgets/corpActions/capsule/store/CorporateActionsCapsulesState';
import { CorporateActionsCapsuleActionPayload } from 'widgets/corpActions/capsule/store/actions';

const { reducer: configReducer } = buildCorporateActionsCapsuleConfigSlice();

const corporateActionsCapsuleWidgetReducer =
    combineReducers<CorporateActionsCapsuleState>({
        config: configReducer,
    });

export const corporateActionsCapsuleWidgetsReducer = createWidgetsReducer<
    CorporateActionsCapsuleState,
    CorporateActionsCapsuleActionPayload
>(WidgetType.CORPORATE_ACTIONS_CAPSULE, corporateActionsCapsuleWidgetReducer);
